export const initProgressBar = (initialBarEl, contentEl) => {
  const progressBar = initialBarEl || document.querySelector('.content-progress-bar');
  const content = contentEl || document.querySelector('.content__wrapp');

  if (!progressBar || !content) return;

  // Initially hide the progress bar
  progressBar.style.display = 'none';
  progressBar.style.opacity = '0';

  // Add click handler to hide progress bar
  progressBar.addEventListener('click', () => {
    progressBar.style.opacity = '0';
    // Remove from DOM after transition
    setTimeout(() => {
      progressBar.style.display = 'none';
    }, 300); // Match this with CSS transition duration
  });

  // Create SVG elements
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', 'progress-ring');
  svg.setAttribute('viewBox', '0 0 72 72');

  const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('class', 'progress-ring__circle');
  circle.setAttribute('cx', '36');
  circle.setAttribute('cy', '36');
  circle.setAttribute('r', '34');
  circle.setAttribute('fill', 'white');
  circle.setAttribute('stroke', 'none');
  circle.setAttribute('stroke-linecap', 'round');

  // const textDiv = document.createElement('div');
  // textDiv.className = 'progress-text';
  // textDiv.textContent = '0%';

  // Add elements to DOM
  svg.appendChild(circle);
  progressBar.appendChild(svg);
  // progressBar.appendChild(textDiv);

  // Calculate circle properties
  const radius = circle.r.baseVal.value;
  const circumference = radius * 2 * Math.PI;
  circle.style.strokeDasharray = `${circumference} ${circumference}`;
  circle.style.strokeDashoffset = circumference;

  const setProgress = (percent) => {
    const offset = circumference - (percent / 100 * circumference);
    circle.style.strokeDashoffset = offset;
    // textDiv.textContent = `${Math.round(percent)}%`;
  };

  let isVisible = false;
  let hideTimeout;
  let rafId = null;

  const showProgressBar = () => {
    if (isVisible) return;
    clearTimeout(hideTimeout);
    isVisible = true;
    progressBar.style.display = 'flex';
    progressBar.offsetHeight;
    progressBar.style.opacity = '1';
  };

  const hideProgressBar = () => {
    if (!isVisible) return;
    isVisible = false;
    progressBar.style.opacity = '0';
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      progressBar.style.display = 'none';
    }, 300);
  };

  const updateProgress = () => {
    const contentBox = content.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const offset = 0;

    const startTrigger = contentBox.top + offset;
    const endTrigger = contentBox.bottom - windowHeight;

    // Hide progress bar when near the bottom of content
    const nearBottom = contentBox.bottom <= windowHeight + 10; // 10px from bottom
    if (nearBottom) {
      hideProgressBar();
      rafId = null;
      return;
    }

    // Show/hide progress bar based on scroll position
    if (startTrigger <= 0) {
      showProgressBar();
    } else {
      hideProgressBar();
    }

    const scrollDistance = endTrigger - startTrigger;
    const scrolled = -startTrigger;
    const progress = (scrolled / scrollDistance) * 100;

    setProgress(Math.min(100, Math.max(0, progress)));

    rafId = null;
  };

  // Throttled scroll handler using requestAnimationFrame
  const onScroll = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(updateProgress);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // Initial call
  updateProgress();

  // Cleanup function
  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    if (rafId) cancelAnimationFrame(rafId);
    clearTimeout(hideTimeout);
  };
};